const wraptables = () => {
    const tables = Array.from(document.querySelectorAll('.content table'));
    tables.forEach((table) => {
        // eslint-disable-next-line no-param-reassign
        table.outerHTML = `<div class="table-wrapper">${table.outerHTML}</div>`;
    });
};
document.addEventListener('DOMContentLoaded', wraptables);

export { wraptables };
